module.exports = __webpack_public_path__ + "img/66acd93.jpg";